export default __webpack_public_path__ + "static/media/The Subtle Disguise.f6c71be4.jpg";